import warehouseScreenshot1 from "@me-team/common/src/images/modules/warehouse-screenshot_1.png";
import warehouseScreenshot2 from "@me-team/common/src/images/modules/warehouse-screenshot_2.png";
import warehouseScreenshot3 from "@me-team/common/src/images/modules/warehouse-screenshot_3.png";
import warehouseScreenshot4 from "@me-team/common/src/images/modules/warehouse-screenshot_4.png";
import warehouseScreenshot5 from "@me-team/common/src/images/modules/warehouse-screenshot_5.png";
import warehouseScreenshot6 from "@me-team/common/src/images/modules/warehouse-screenshot_6.jpg";

export interface WarehouseItem {
    text: string;
    subItems?: string[];
}

export interface WarehouseModuleDetail {
    title: string;
    items: WarehouseItem[];
    image: string;
    bgClass: string;
    reverse: boolean;
}
export const warehouseModuleDetailsData: WarehouseModuleDetail[] = [
    {
        title: "Warehouse and inventory management",
        items: [
            { text: "creation and management of multiple warehouses;" },
            { text: "tracking of goods and consumables;" },
            { text: "adding goods to the warehouse, writing off, and transferring between warehouses;" },
            { text: "real-time stock level monitoring." },
        ],
        image: warehouseScreenshot1,
        bgClass: "ellipse-bg-modules-right",
        reverse: false,
    },
    {
        title: "Technological maps",
        items: [
            {
                text: "creating technological maps for services;",
            },
            {
                text: "automatic deduction of consumables after task completion;",
            },
            {
                text: "flexible configuration of the warehouse and material quantities for each service.",
            },
        ],
        image: warehouseScreenshot2,
        bgClass: "ellipse-bg-modules-left",
        reverse: true,
    },
    {
        title: "Sale Products",
        items: [
            { text: "selling products directly from the warehouse;" },
            { text: "selling products through a client appointment;" },
            { text: "automatic stock updates after a sale." },
        ],
        image: warehouseScreenshot3,
        bgClass: "ellipse-bg-modules-right",
        reverse: false,
    },
    {
        title: "Operations tracking and history",
        items: [
            {
                text: "complete list of warehouse operations:",
                subItems: ["receipt;", "write-off;", "transfer;", "sale."],
            },
            {
                text: "ability to edit operations (based on access rights);",
            },
            {
                text: "detailed history of creation and changes for all product operations.",
            },
        ],
        image: warehouseScreenshot4,
        bgClass: "ellipse-bg-modules-left",
        reverse: true,
    },
    {
        title: "Analytics and reports",
        items: [
            { text: "product sales statistics;" },
            { text: "sales statistics by masters;" },
            {
                text: "reports on product operations:",
                subItems: ["receipt;", "write-off;", "transfer;", "sale."],
            },
        ],
        image: warehouseScreenshot5,
        bgClass: "ellipse-bg-modules-right",
        reverse: false,
    },
    {
        title: "The module is ideal for businesses that:",
        items: [
            {
                text: "deal with goods and consumables;",
            },
            {
                text: "provide services that use materials;",
            },
            {
                text: "want to have transparent inventory management and stock control.",
            },
        ],
        image: warehouseScreenshot6,
        bgClass: "ellipse-bg-modules-left",
        reverse: true,
    },
];
